import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { paidReasons } from './constants'

const PaidReasonSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      fullWidth
      menuItems={paidReasons.map(o => ({ label: t(o.label), value: o.value }))}
      label={t('Motivo')}
      value={value}
      handleChange={onChange}
    />
  )
}

export default PaidReasonSelector
